import { Injectable } from '@angular/core';
import { BaseService } from '../../../core/service/base-service';
import { HttpClient } from '@angular/common/http';
import { AuthUtilsService } from '../../../core/util/auth-utils.service';
import { Puritymodal } from '../modal/puritymodal';

@Injectable({
  providedIn: 'root',
})
export class PurityService extends BaseService<Puritymodal> {
  pagination: { pageIndex: number; perPage: number };
  constructor(http: HttpClient, authService: AuthUtilsService) {
    super(http, authService);
  }

  getModuleName(): string {
    return 'chemical/purity';
  }

  validate(): boolean {
    return false;
  }
}
